<button (click)="onClick()"
    class="flex items-center justify-center w-full h-12 border border-border rounded-lg bg-white hover:bg-neutral-100 focus:ring-1 focus:ring-primary max-w-screen-sm">
    <img [src]="iconSrc" [alt]="iconAltText" class="w-5 h-5 mr-3" />
    <span class="text-black font-medium">{{ buttonText }}</span>
</button>